import Icon from 'components/global/Icon';
import MinimizeButton from 'components/global/MinimizeButton';
import Typography from 'components/global/Typography';

import { faCheckCircle, faClock, faXmarkCircle } from '@fortawesome/pro-solid-svg-icons';

import * as S from './MinimizedShipmentButton.styled';

const MinimizedShipmentButton = ({ label, onShow, onClose, successCount, failedCount, totalCount }) => {
	const isSuccess = successCount === totalCount && successCount > 0;
	const isFailed = failedCount > 0;

	return (
		<MinimizeButton
			label={label}
			onShow={onShow}
			onClose={onClose}
			icon={isSuccess ? faCheckCircle : isFailed ? faXmarkCircle : faClock}
			iconColor={isSuccess ? 'var(--green)' : isFailed ? 'var(--red)' : 'var(--yellow)'}
			tooltip={
				<S.TooltipContainer>
					<S.TooltipRow>
						<Typography fontWeight="500">
							{totalCount - (successCount + failedCount)}/{totalCount}
						</Typography>
						<Icon icon={faClock} color="var(--yellow)" />
						<Typography fontWeight="500">pending</Typography>
					</S.TooltipRow>
					<S.TooltipRow>
						<Typography fontWeight="500">
							{successCount}/{totalCount}
						</Typography>
						<Icon icon={faCheckCircle} color="var(--green)" />
						<Typography fontWeight="500">completed</Typography>
					</S.TooltipRow>
					<S.TooltipRow>
						<Typography fontWeight="500">
							{failedCount}/{totalCount}
						</Typography>
						<Icon icon={faXmarkCircle} color="var(--red)" />
						<Typography fontWeight="500">failed</Typography>
					</S.TooltipRow>
				</S.TooltipContainer>
			}
		/>
	);
};

export default MinimizedShipmentButton;
